import React from 'react';
import propTypes from 'prop-types';
import { Button, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Content } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePoseWithBulma, FadeInDiv, AnimatedCard } from 'src/ui';
export function SubmissionModal({ title, content, isActive, onClickClose }) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Modal isActive={isModalVisible} className="confirm-changes-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <ModalCardHeader>
          <ModalCardTitle
            tag="h6"
            hasTextAlign="centered"
            className="has-text-weight-semibold"
          >
            {title}
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody hasTextAlign="centered">
          <span className="icon is-large has-icon-gradient-bright">
            <FontAwesomeIcon
              icon={['fal', 'check-circle']}
              className="is-size-2"
            />
          </span>
          <Content className="has-text-grey-medium-dark">{content}</Content>
          <div className="buttons is-centered">
            <Button
              isOutlined
              className="is-long"
              hasTextColor="info"
              onClick={onClickClose}
            >
              Close
            </Button>
          </div>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

SubmissionModal.propTypes = {
  title: propTypes.string.isRequired,
  content: propTypes.oneOfType([propTypes.node, propTypes.element]).isRequired,
  isActive: propTypes.bool.isRequired,
  onClickClose: propTypes.func.isRequired,
};
